import { useAuth } from "context/AuthContext";
import React from "react";
import { useTranslation } from "react-i18next";
import { HigherAdminFeedback, Roles } from "types";
import { feedbackIcon } from "utils/constant";
import { hasRole } from "utils/helper";

type Props = {
  requestId: number | string;
  fetchData: () => void;
  respondback_feedbacks: HigherAdminFeedback[];
};

const HigherAdminRespondbackFeedback: React.FC<Props> = ({
  requestId,
  fetchData,
  respondback_feedbacks,
}) => {
  const { loginData } = useAuth();
  const { t } = useTranslation();
  const isCoordinator = hasRole(loginData?.roles, [Roles.coordinator]);

  return (
    <div className="">
      <h1 className="text-black font-semibold text-base flex flex-row gap-2 ml-6">
        {feedbackIcon} {t("respond_back_section")}
      </h1>
      <div
        className={`flex flex-col gap-4 mt-4 justify-between h-[${
          isCoordinator ? "60vh" : "60vh"
        }] w-full`}
      >
        <div className="flex flex-col overflow-y-auto gap-2">
          <div
            className={`flex flex-col gap-4 justify-between h-[${
              isCoordinator ? "60vh" : "60vh"
            } w-full`}
          >
            {respondback_feedbacks?.length === 0 && (
              <p className="text-gray-500 text-sm ml-6">
                {t("no_respond_back_available")}
              </p>
            )}
            <div className="flex flex-col gap-0 w-full">
              {respondback_feedbacks?.map((feedback, index) => (
                <div
                  key={index}
                  className={`${
                    index % 2 === 0 ? "bg-white" : "bg-gray-100"
                  } px-6 py-4 rounded-md shadow-sm`}
                  style={{
                    overflowWrap: "break-word",
                  }}
                >
                  <div className="flex justify-between items-center">
                    <p className="text-xs font-medium text-red-600">
                      {t("commented_date")}
                    </p>
                    <p className="text-xs text-gray-700">
                      {feedback?.created_at &&
                        new Date(feedback?.created_at).toLocaleString()}
                    </p>
                  </div>
                  <div className="flex items-center gap-2 mt-2">
                    <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-gray-200 text-gray-600 text-xs font-bold">
                      {feedback?.feedback_by && feedback?.feedback_by[0]}
                    </span>
                    <span className="text-xs text-gray-700">
                      <span className="font-semibold text-gray-900">
                        {t("by_label")}:
                      </span>{" "}
                      {feedback?.feedback_by}
                    </span>
                  </div>
                  <div className="mt-3 flex flex-col gap-2">
                    <p className="text-sm text-gray-800 whitespace-pre-line">
                      {feedback?.feedback_text}
                    </p>

                    {feedback.feedback_file && (
                      <div className="border rounded-lg p-3 flex items-center gap-4 bg-[#F8F8F8] mb-2">
                        <img
                          src={require("../../../images/imageVector.png")}
                          alt={t("feedback_file")}
                          className="w-10 h-10"
                        />
                        <div className="flex-1">
                          <p className="font-semibold text-base text-[#0A1D39]">
                            {t("feedback_file")}
                          </p>
                        </div>
                        <button
                          type="button"
                          className="text-[#212121] text-sm font-semibold border px-4 py-1 rounded hover:bg-gray-100"
                          onClick={() => {
                            if (
                              typeof feedback?.feedback_file === "string" &&
                              feedback?.feedback_file
                            ) {
                              window.open(feedback?.feedback_file, "_blank");
                            } else if (
                              feedback?.feedback_file instanceof File
                            ) {
                              window.open(
                                URL.createObjectURL(feedback?.feedback_file),
                                "_blank",
                              );
                            }
                          }}
                        >
                          {t("view")}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HigherAdminRespondbackFeedback;
